import React from 'react';
import './PurpleButton.css';

const PurpleButton = ({ text = "Get A Quote", onClick }) => {
  return (
    <button className="purple-button" onClick={onClick}>
      <span className="button-text">{text}</span>
      <span className="button-icon">
        <i className="fas fa-arrow-right"></i>
      </span>
    </button>
  );
};

export default PurpleButton; 